import type { SubjectCode } from '~/models/Subject'
import type { GradeCode } from '~/models/Grade'
import type {
  Assignment,
  AssignmentAnswer,
  AssignmentReportAlternatives,
  AssignmentResponse,
  PaginatedReport,
  ReportType
} from '~/models/Assignment'
import { externalClient } from '~/api/client/externalClient'

export default function useAssignmentApi() {
  return {
    getAssignmentResponse: async (assignmentKey: string, groupIds: string[]): Promise<AssignmentResponse[]> =>
      (await externalClient.get(`/frontend/assignment/${assignmentKey}/response?groupIds=${groupIds}`)).data,

    getAssignment: async (assignmentKey: string): Promise<Assignment> =>
      (await externalClient.get(`/frontend/assignment/${assignmentKey}`)).data,

    getStudentAssignmentResponse: async (assignmentKey: string, studentUserId: string): Promise<AssignmentResponse> =>
      (await externalClient.get(`/frontend/assignment/${assignmentKey}/response/${studentUserId}`)).data,

    saveStudentAssignment: async (assignmentKey: string, studentUserId: string, answer: AssignmentAnswer): Promise<AssignmentAnswer> =>
      (await externalClient.put(`/frontend/assignment/${assignmentKey}/response/${studentUserId}/answer`, answer)).data,

    createStudentAssignment: async (assignmentKey: string, studentUserId: string, answer: AssignmentAnswer): Promise<AssignmentAnswer> =>
      (await externalClient.post(`/frontend/assignment/${assignmentKey}/response/${studentUserId}/answer`, answer)).data,

    getReportAlternatives: async (): Promise<AssignmentReportAlternatives> =>
      (await externalClient.get('/frontend/assignment/report/alternatives')).data,

    getReport: async (
      groupId: string | undefined,
      lastActivityAfter: string | null | undefined,
      lastActivityBefore: string | null | undefined,
      contentType: ReportType | undefined,
      context: string | undefined,
      subject: SubjectCode | undefined,
      grade: GradeCode | string | null | undefined,
      pageNumber: number = 1,
      pageSize: number = 24,
      includeUnansweredAssignments: boolean = true,
    ): Promise<PaginatedReport> =>
      (await externalClient.get('/frontend/assignment/report/page', {
        params: {
          groupId,
          lastActivityAfter,
          lastActivityBefore,
          contentType,
          context,
          subject,
          grade,
          pageNumber,
          pageSize,
          includeUnansweredAssignments
        }
      })).data
  }
}
